export const FadeDurationInSeconds = 0.4;

export const animationOptions = {
  loop: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
